const messages = {
  en: {
    // status
    Unread: 'Not seen yet',
    Read: 'Read',
    Undelivered: 'Being delivered',
    Delivered: 'Delivered',
    // file
    BrwoserAudio: 'Your browser does not support the audio tag.',
    BrowserVideo: 'Your browser does not support the video tag.',
    Download: 'Download',
    Remove: 'Remove',
    // general
    Send: 'Send',
    // emoji
    People: 'People',
    Nature: 'Nature',
    Objects: 'Objects',
    Places: 'Places',
    Symbols: 'Symbols',
    // connection
    ConnectionLost: 'Connection Lost',
    Refresh: 'Refresh',
    unsupported_type: 'File type is not supported',
    unsupported_size: 'Maximum size: 2.5Mb',
    loading: 'Loading ...',
    Close: 'Close',
    Back: 'Back',
  },
  fr: {
    // status
    Unread: 'Pas encore vu',
    Read: 'Vu',
    Undelivered: 'En cours de livraison',
    Delivered: 'Livré',
    // file
    BrwoserAudio: 'Votre navigateur ne supporte pas la balise audio.',
    BrowserVideo: 'Votre navigateur ne supporte pas la balise vidéo.',
    Download: 'Téléchargement',
    Remove: 'Supprimer',
    // general
    Send: 'Envoyer',
    // emoji
    People: 'Personnes',
    Nature: 'Nature',
    Objects: 'Objets',
    Places: 'Lieux',
    Symbols: 'Symboles',
    // connection
    ConnectionLost: 'Connexion Perdue',
    Refresh: 'Rafraîchir',
    unsupported_type: "Ce type de fichier n'est pas autorisé",
    unsupported_size: 'La taille du fichier dépasse 2.5Mo',
    loading: 'Chargement ...',
    Close: 'Fermer',
    Back: 'Retour',
  },
};

const detectedLanguage = (
  navigator.language ||
  navigator.userLanguage ||
  'en'
).substring(0, 2);

const language =
  Object.keys(messages).indexOf(detectedLanguage) !== -1
    ? detectedLanguage
    : 'en';

export default {
  locale: language,
  fallbackLocale: language,
  messages,
};
